/**
 * default placeholder in react-select is a hard-coded, non-translatable text "Select...".
 * This wraps controls such that the text gets translated
 */
import React from "react";
import { useTranslation } from "react-i18next";
import Select, { Creatable } from "react-select";
export * from "react-select";
function SelectWrap(props) {
    const { t } = useTranslation();
    if (props.placeholder === undefined) {
        props = {
            ...props,
            placeholder: t("Select..."),
        };
    }
    return React.createElement(Select, { ...props });
}
function CreatableWrap(props) {
    const { t } = useTranslation();
    if (props.placeholder === undefined) {
        props = {
            ...props,
            placeholder: t("Select..."),
        };
    }
    return React.createElement(Creatable, { ...props });
}
export { CreatableWrap as Creatable };
export default SelectWrap;
